import { useMediaQuery } from '@react-hook/media-query';
import React from 'react';

import { SkeletonPlaceholder } from 'src/shared/ds/components/SkeletonPlaceholder';
import { HeadingText50, HeadingText60 } from '../Typography';
import { mediaQuery } from '../variables';

export const PageHeader: React.FC = ({ children }) => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));

    const TextComponent = smallScreenDetected ? HeadingText50 : HeadingText60;

    return (
        <TextComponent marginTop={48} marginBottom={20}>
            {children}
        </TextComponent>
    );
};

export const PageHeaderSkeleton: React.FC = () => (
    <SkeletonPlaceholder width={220} height={40} marginTop={46} marginBottom={24} />
);
